import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: '',
    template: ''
})
export class ReloadComponent { }
